import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70fc0a6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-recovery-modal__text mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Хорошие новости — "),
  /*#__PURE__*/_createElementVNode("b", null, "звонки и онлайн-доски уже доступны!")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-recovery-modal__text mb-1" }, "Что пока не работает:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "service-recovery-modal__text mb-3 ps-4" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Запись звонков"),
  /*#__PURE__*/_createElementVNode("li", null, "Отправка уведомлений по электронной почте")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-recovery-modal__text bg-primary text-white rounded-3 p-3 mb-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold mb-2" }, "Как добавлять новых учеников?"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Пока отправка email-сообщений недоступна, вы можете добавлять новых учеников без подтверждения по электронной почте. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-recovery-modal__text mb-3" }, " Мы продолжаем устранять оставшиеся неполадки и сообщим, когда все функции будут полностью восстановлены. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-recovery-modal__text mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Если у вас возникли вопросы, напишите нам на официальную почту службы поддержки: "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@finch.study" }, "support@finch.study"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-recovery-modal__text mb-3" }, "Спасибо за терпение и понимание!", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-recovery-modal__text mb-0" }, [
  /*#__PURE__*/_createTextVNode(" С уважением"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Команда Finch ")
], -1))

import { ref } from 'vue';
import TariffNotificationModal from '../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceRecoveryModal',
  emits: ["hidden"],
  setup(__props, { expose: __expose, emit: __emit }) {

// Модалка «Восстанавливаем работу Finch» (FINCH-2631). Чисто информационная:
// закрывается крестиком, факт показа фиксирует хост по событию hidden.
const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = __emit;

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Восстанавливаем работу Finch",
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden'))),
    "max-width": 500,
    "without-buttons": ""
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8
    ]),
    _: 1
  }, 512))
}
}

})